module.exports = __webpack_public_path__ + "img/informed.93108ef4.png";